import { usePageSeo } from "@/lib/seo";
import ReviewWidget from "@/components/site/ReviewWidget";
import { QuoteSection } from "@/components/site/Sections";

export default function Blog() {
  usePageSeo("/blog");
  return (
    <>
      <section className="mx-auto max-w-7xl px-5 py-16 md:px-8 lg:py-24" data-testid="blog-page">
        <p className="eyebrow mb-3">Blog</p>
        <h1 className="text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl lg:text-6xl">News & flooring advice.</h1>
        <p className="mt-5 max-w-2xl text-slate-400">Project updates, maintenance tips and what to know before you choose a commercial or residential concrete finish.</p>
        <div className="mt-10 rounded-sm bg-white p-4 md:p-8">
          <ReviewWidget type="blog" />
        </div>
      </section>
      <QuoteSection />
    </>
  );
}
